export enum DeatilsOperations {
  add,
  edit,
}
